module.exports = __webpack_public_path__ + "static/media/PaidFull.59dc9129.svg";